
import gql from 'graphql-tag'
import userFavProductTermLife from '@/apollo/queries/user/userFavProductTermLife'
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment'
import termCITooltips from '~/apollo/queries/product/tooltips/termCITooltips'
import termLifeBenchmark from '~/apollo/queries/product/termLifeBenchmark';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: "FavProductTermLifeCard",
  mixins: [productPromotionMixins, productInsuranceNameMixins],
  data: () => ({
    product: Object,
    productLoading: 0,
    benchmarkLoading: 0,
    currentLink: "",
  }),
  props: {
    productId: String,
    params: String,
    favProductId: String,
  },
  apollo: {
    product: {
      // prefetch: true,
      loadingKey: "productLoading",
      query: gql`${userFavProductTermLife} ${productPromotionFragment}`,
      variables() {
        const returnObj = {};

        returnObj.id = this.productId;
        returnObj.locale = this.$normalizeLocale(this.$i18n.locale);

        console.debug(returnObj);

        return returnObj;
      },
      update(data) {
        return data?.termLifePlanScenarios?.data;
      },
      result({ data }) {
        // console.debug(JSON.stringify(data?.termLifePlanScenarios?.data));
      },
    },
    tooltips: {
      query: termCITooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data).TermCI;
      },
    },
    termLifeBenchmarks: {
      query: termLifeBenchmark,
      loadingKey: "benchmarkLoading",
      prefetch: true,
      variables() {;
        const gender = parseInt(this.simpleParams.gender);
        const age = parseInt(this.simpleParams.age);
        const sum_assured = parseInt(this.simpleParams.sum_assured) || '1000000'
        // console.debug(gender);
        // console.debug(age);
        return {
          gender,
          age,
          sum_assured
        };
      },
    },
  },
  computed: {
    simpleItem() {
      if (!this.productLoading && !this.benchmarkLoading) {
        if (this.product) {
          return this.product.map((item) => {
            let promotionPrices = Array;
            promotionPrices = [];

            let tenYearConstant = 0;
            let twentyYearConstant = 0;
            // get termlife rating calculation constant
            this.termLifeBenchmarks.data.forEach((item) => {
              if(item.attributes.Year === 10)
                tenYearConstant = item.attributes.BenchmarkValue;
              if(item.attributes.Year === 20)
                twentyYearConstant = item.attributes.BenchmarkValue;
            });

            let discountedTenYearAvgPremium = null;
            let discountedTwentyYearAvgPremium = null;
            let tenYearRating = item.attributes.ten_year_rating;
            let twentyYearRating = item.attributes.twenty_year_rating;
            let promotions = null;
            let promotion = null;
            let promotion_last_call = null;

            const planName = item.attributes.term_life_plan.data.attributes.term_life_plan_translations.data[0].attributes.name;
            const insurer = item.attributes.term_life_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
            const link = this.currentLink;
            let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.termLife.tl_categoryName'), insurer, planName, { page: this.$route.name?.split('__')[0], link: link });
            let decoderCTAText = '';

            // calculate promotion price and avg premium
            const premium = item.attributes.term_life_plan_premium;
            const age = parseInt(this.simpleParams.age);
            const renewalTerm = item.attributes.renewal_term;
            const sumAssured = item.attributes.sum_assured;
            const originalPrices = this.getPremium(premium, age, renewalTerm, sumAssured);
            const fyp = parseFloat(originalPrices[0]).toFixed(0);

            // check scenario level promo first , then plan level promotion 
            if (item.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.product_promotions.data;
            }
            if (item.attributes.term_life_plan.data.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.term_life_plan.data.attributes.product_promotions.data;
            }
            
            if(promotions != null) {
              promotion = this.checkPromotionValid(promotions);
              promotion_last_call = this.checkPromotionLastCall(promotion);

              if (!promotion) {
                promotion = null;
              }
              else {
                if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                  decoderCTALink =
                    promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                  decoderCTAText = this.$t('products.product_website');
                }
                const discounts = promotion.attributes.DiscountPercentage;
                if (discounts) {

                  const calulatedValue = this.calculateDiscountedPremium(originalPrices, discounts);
                  promotionPrices = calulatedValue.promotionPrices;
                  discountedTenYearAvgPremium = calulatedValue.discountedTenYearAvgPremium;
                  discountedTwentyYearAvgPremium = calulatedValue.discountedTwentyYearAvgPremium;

                  const ratings = this.calculateTermlifeScore(
                    tenYearConstant, twentyYearConstant, discountedTenYearAvgPremium, discountedTwentyYearAvgPremium, item.attributes.sum_assured, item.attributes.coverage_score
                  );

                  if (ratings) {
                    tenYearRating = ratings.tenYearRating;
                    twentyYearRating = ratings.twentyYearRating;
                  }

                  if (discountedTenYearAvgPremium === parseInt(item.attributes.ten_year_avg_premium.toFixed(0))) {
                    discountedTenYearAvgPremium = null;
                  }

                  if (discountedTwentyYearAvgPremium === parseInt(item.attributes.twenty_year_avg_premium.toFixed(0))) {
                    discountedTwentyYearAvgPremium = null;
                  }
                }
              }
            }

            const filteredTranslations = this.getFilteredTranslations(item.attributes.term_life_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
            .insurance_company_translations.data[0].attributes.localizations.data);

            return {
              scenario_code: item.attributes.scenario_code,
              sum_assured: item.attributes.sum_assured,
              // ten_year_rating: item.attributes.ten_year_rating,
              // twenty_year_rating: item.attributes.twenty_year_rating,
              ten_year_rating: tenYearRating,
              twenty_year_rating: twentyYearRating,
              ten_year_avg_premium: item.attributes.ten_year_avg_premium,
              twenty_year_avg_premium: item.attributes.twenty_year_avg_premium,
              coverage_score: item.attributes.coverage_score,
              renewal_term: item.attributes.renewal_term,
              underwriting: item.attributes.underwriting,
              overall_star: item.attributes.overall_star,
              // plan
              plan_code: item.attributes.term_life_plan.data.attributes.plan_code,
              issue_age_from: item.attributes.term_life_plan.data.attributes.issue_age_from,

              plan_name:
                item.attributes.term_life_plan.data.attributes.term_life_plan_translations.data[0].attributes.name,
              underwriting_text:
                item.attributes.term_life_plan.data.attributes.term_life_plan_translations.data[0].attributes
                  .underwriting_text,

              // // insurer
              insurer_name_first:
                item.attributes.term_life_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                  .insurance_company_translations.data[0].attributes.name,
              insurer_name_second:
                filteredTranslations[0].attributes.name,
              insurer_logo:
                item.attributes.term_life_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                  .logo,
              insurer_code:
                item.attributes.term_life_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                  .code,
              scenarioID: item.id,

              first_year_premium: fyp,
              product_promotion: promotion,
              promotion_prices: promotionPrices,
              promotion_last_call: promotion_last_call,

              discounted_ten_year_avg_premium: discountedTenYearAvgPremium,
              discounted_twenty_year_avg_premium: discountedTwentyYearAvgPremium,
              decoder_cta_link: decoderCTALink,
              decoder_cta_text: decoderCTAText,
            };
          })[0];
        }
      }
      return null;
    },

    displayProduct() {
      if (this.simpleItem) {
        return {
          favProductId: this.favProductId,
          id: this.simpleItem.scenario_code,
          scenarioId: this.simpleItem.scenarioID,
          productType: "term-life",
          category: this.category,
          showFiveStarBadge: this.$formatShowFiveStarBadge(this.simpleItem.overall_star),
          showTrending: false,
          productLink: this.$extendPath(
            '/products/term-life',
            '/' +
            this.simpleItem.scenario_code + '?' + this.params
          ),
          productName: this.simpleItem.plan_name,
          insuranceCompany: {
            name: this.simpleItem.insurer_name_first + ' | ' + this.simpleItem.insurer_name_second,
            code: this.simpleItem.insurer_code,
            logoSrc: this.simpleItem.insurer_logo?.data?.attributes.url,
            logoAlt: this.simpleItem.insurer_name_first,
          },
          userRating: {
            score: this.simpleItem.overall_star,
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: parseFloat(this.getScore(this.simpleItem)),
            description: this.$t('products.termLife.tl_10LifeRating'),
            toolTipHtml: this.getTooltipContentByKey('tl_termLifeScore'),
          },
          features: [
            {
              text: this.simpleItem.underwriting_text,
              type: 'underwriting',
            },
          ],
          keyItems: [
            {
              value:
                '<span style="white-space: nowrap;">' +
                this.simpleItem.coverage_score.toFixed(1).toString() +
                ' / <small>10</small> </span>',
              key: this.$t('products.termLife.tl_termsScore'),
              topSubText: '',
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.getRenewal(this.$t('products.renewalUnit'), this.simpleItem.renewal_term),
              key: this.$t('products.renewalTerm'),
              topSubText: '',
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.simpleItem.discounted_ten_year_avg_premium
                ? this.simpleParams.targetPeriod === '10'
                  ? this.simpleItem.discounted_ten_year_avg_premium
                  : this.simpleItem.discounted_twenty_year_avg_premium
                : this.getAvgPremium(this.simpleItem),
              key: this.simpleParams.targetPeriod + this.$t('products.termLife.tl_YearAveragePremium'),
              topSubText: 'HKD',
              toolTipHtml: '',
              symbolValue: '',
              originalValue: this.simpleItem.discounted_ten_year_avg_premium ? this.getAvgPremium(this.simpleItem) : '',
            },
          ],
          compactKeyItems: [
            {
              value: this.simpleItem.promotion_prices[0]
                ? parseInt(this.simpleItem.promotion_prices[0]).toLocaleString('en-US')
                : parseInt(
                  this.simpleItem.first_year_premium
                ).toLocaleString('en-US'),
              key: this.$t('products.termLife.tl_firstYearPremium'),
              topSubText: 'HKD',
              toolTipHtml: '',
              symbolValue: '',
              originalValue: this.simpleItem.promotion_prices[0]
                ? parseInt(
                  this.simpleItem.first_year_premium
                ).toLocaleString('en-US')
                : '',
              // if isDiscount ? discountPrice : OriginalPrice
            },
            {
              value: this.simpleItem.coverage_score.toFixed(1).toString() + ' / <small>10</small>',
              key: this.$t('products.termLife.tl_termsScore'),
              topSubText: '',
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
            },
          ],
          promotion: {
            category:
              this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
            title:
              this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
            ctaButtonLink:
              this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
            ctaButtonText:
              this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
            promotionId: this.simpleItem.product_promotion?.id,
            scenarioId: this.simpleItem.scenarioID,
            lastCall: this.simpleItem.promotion_last_call

          },
          mainButtonCTA: {
            text: this.simpleItem.decoder_cta_text,
            link: this.simpleItem.decoder_cta_link,
          },
          price: {
            originalPrice: this.simpleItem.promotion_prices[0]
              ? parseInt(
                this.simpleItem.first_year_premium
              ).toLocaleString('en-US')
              : '',
            discountPrice: this.simpleItem.promotion_prices[0]
              ? parseInt(this.simpleItem.promotion_prices[0]).toLocaleString('en-US')
              : parseInt(
                this.simpleItem.first_year_premium
              ).toLocaleString('en-US'),
            prefix: 'HKD',
            postfix: '',
            subText: this.$t('products.termLife.tl_firstYearPremium'),
            toolTipHtml: '',
          },
        };
      }
      return null
    },

    simpleParams() {
      let vars = Array;
      vars = [];
      const hash = this.params.split('&');

      for (let i = 0; i < hash.length; i++) {
        const params = hash[i].split("=");
        vars[params[0]] = params[1];
      }

      return vars;
    }
  },
  watch: {
    product() {
      if (this.product.length) {
        this.$emit("product-load", 'TLife');
      } else {
        try {
          throw new Error("*** Product not found ***");
        } catch (e) {
          console.error(e.name + ": " + e.message);
          this.$sentry.captureException(e);
        }
      }
    },
  },
  mounted() {
    this.currentLink = window.location.href;
  },
  updated() {
    if (this.simpleItem) {
      this.$emit("productTitle", { id: this.favProductId, companyName: this.simpleItem.insurer_name_first, title: this.simpleItem.plan_name });
    }
  },
  methods: {
    getScore(product) {
      if (this.simpleParams.targetPeriod === '10') {
        return product.ten_year_rating.toFixed(1);
      } else if (this.simpleParams.targetPeriod === '20') {
        return product.twenty_year_rating.toFixed(1);
      }
      return 0;
    },
    getAvgPremium(product) {
      if (this.simpleParams.targetPeriod === '10') {
        return product.ten_year_avg_premium.toLocaleString('en-US');
      } else if (this.simpleParams.targetPeriod === '20') {
        return product.twenty_year_avg_premium.toLocaleString('en-US');
      }
      return 0;
    },

    getRenewal(label, renewalTerm) {
      if (renewalTerm === 1) {
        return this.$t('products.annualRenewal');
      }
      return label.replace('$num', renewalTerm);
    },

    getPremium(premium, startAge, renewalTerm, sumAssured) {
      const totalYear = 20;
      const result = new Array(20);
      const session = totalYear / renewalTerm;
      let lockedPremium = 0;

      for (let i = 0; i < session; i++) {
        // lock by the first year in the renewal_term

        lockedPremium = (premium.data.attributes['age_' + (parseInt(startAge) + i * renewalTerm)] * sumAssured / 1000).toFixed(2);
        for (let j = 0; j < renewalTerm; j++) {
          result[i * renewalTerm + j] = lockedPremium;
        }
      }
      return result;
    },

    getTooltipContentByKey(mKey) {
      return this.tooltips?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    unfavourite() {
      this.product = null;
    },
  },
}
